import React, { useEffect, useMemo, useState } from 'react';

// material-ui
import {
  AppBar,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  IconButton,
  MenuItem,
  Paper,
  Slide,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
  TablePagination,
  Badge
} from '@mui/material';
import Dialog from '@mui/material/Dialog';

import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import LinkIcon from '@mui/icons-material/Link';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import moment from 'moment';


// project imports

import Autodesk from 'assets/images/auth/autodesk.webp';
import Excel from 'assets/images/auth/excel.png';
import Redas from 'assets/images/auth/redas_result.webp';
import SGBuildex from 'assets/images/auth/sgbuildex_result.webp';

import GoogleListItemDialog from '../../components/googleDrive/googleListItems';
import ListConnectorsDialog from '../../components/listConnectors';
import {
  useApsDownloadFileCSV,
  useDeactiveSgbuildexElement,
  useDeleteExtraction,
  useExtractETSFile,
  useExtractionList,
  useGetTokenRefreshPBI,
  useRefreshPowerBI,
  useUpdateExtraction,
  useUpdateParameterPowerBI
} from '../../hooks/useExtraction';
import useExtractStore from '../../store/useExtract';
import HubPage from './hub';
import ViewDataPage from './view';
import ConfirmDeleteDialog from '../../components/alert/alertDialog';
import SnackbarAlert from '../../components/alert/alertSnackbar';
import { useApsDownloadFile, useExtractFileExcel } from '../../hooks/useAps';
import { fetchApsDownload } from '../../services/apsService';
import { useExrtactionGoogleSpreadsheet } from '../../hooks/useGoogleDrive';
import useConnectionStore from '../../store/useConnectors';
import { getRefreshTokenPBI, moduleTypes, setRefreshTokenPBI, transformMetadata } from '../../utils/utils';
import ScheduleFormDialog from '../../components/scheduleDialog';
import ScheduleExtractionPage from './schedule';
import SgbuildexModuleScreen from './sgbuildex';
import PowerBIDialog from './dashboard';
import ListActiveElementDialog from '../../components/listActiveSgbuildexElement';
import { useConnections } from '../../hooks/useConnections';
import EditDataPage from './edit';
import { refreshPBI } from '../../services/extractionServices';
import DashboardConfirmDialog from '../../components/tokenPBIDialog';
import RefreshConfirmDialog from '../../components/refreshPBIDialog';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ACTION_RULES = {
  files: ['download', 'delete'],
  excel: ['view', 'delete'],
  'Concrete Cube Test': ['view', 'delete'],
  spreadsheets: ['view', 'delete'],
  default: ['view', 'edit', 'dashboard', 'download', 'delete']
};

const getActionsByModuleType = (moduleType) => {
  return ACTION_RULES[moduleType] || ACTION_RULES.default;
};

const convertToCSV = (data) => {
  if (!Array.isArray(data)) return '';

  const headers = Object.keys(data[0]);

  const rows = data.map((obj) => headers.map((key) => `"${obj[key] ?? ''}"`).join(','));

  return [headers.join(','), ...rows].join('\n');
};

const resolveRemainingToken = (payload) => {
  const defaultDailyLimit = getRefreshTokenPBI();
  const quota = payload?.quota ?? payload?.remainingQuota ?? payload ?? {};

  const directRemaining =
    quota.refreshesRemainingToday ??
    quota.remainingRefreshesToday ??
    quota.refreshesRemaining ??
    quota.remainingRefreshes ??
    quota.remainingQuota ??
    quota.remaining;

  if (directRemaining !== undefined && directRemaining !== null && !Number.isNaN(Number(directRemaining))) {
    return Number(directRemaining);
  }

  const usedToday = Number(quota.refreshesUsedToday);

  if (Number.isFinite(usedToday)) {
    return Math.max(0, defaultDailyLimit - usedToday);
  }

  return defaultDailyLimit;
};

const ActionButton = ({ title, color, icon, onClick }) => (
  <Tooltip title={title}>
    <IconButton
      onClick={onClick}
      size="small"
      sx={{
        border: '1px solid',
        borderColor: `${color}.dark`,
        color: `${color}.dark`,
        '&:hover': {
          bgcolor: `${color}.dark`,
          color: '#fff'
        },
        width: 32,
        height: 32
      }}
    >
      {icon}
    </IconButton>
  </Tooltip>
);

export default function ExtractPage() {
  const { connectionOwnerName, activeConnectionId } = useConnectionStore((s) => s);
  const { hubname, openProject, setCloseProject, setHubName, setDataFormDetail } = useExtractStore();
  const { mutate: deactivateElement, isPending: isDeactivateElement, isSuccess: isSuccessDeactivate } = useDeactiveSgbuildexElement();
  const { data: dataConnection = [], isFetching: isLoadingConnection, isError } = useConnections();
  const {
    mutate: extractGoogleSheet,
    isPending: isExtractingGoogleSheet,
    isSuccess: isSuccessGoogleSheet
  } = useExrtactionGoogleSpreadsheet();

  const { mutate: deleteExtraction, isPending: isDeletingExtraction } = useDeleteExtraction();
  const { mutate: updateExtraction, isPending: isUpdatingExtraction } = useUpdateExtraction();
  const { mutate: updateParameterPowerBI, isPending: isUpdateParameterPowerBI } = useUpdateParameterPowerBI();
  const { mutate: refreshPowerBI, isPending: isRefreshPowerBI } = useRefreshPowerBI();
  const { mutate: extractExcel, isPending: isExtractingExcel } = useExtractFileExcel();
  const { mutate: extractEtsExcel, isPending: isExtractingEtsExcel } = useExtractETSFile();

  const [typeModule, settypeModule] = useState('all');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openSgbuildexModule, setopenSgbuildexModule] = useState(false);

  const {
    data: dataExtraction,
    isFetching: isLoadingExtraction,
    isError: isErrorExtraction
  } = useExtractionList({
    type: typeModule == 'all' ? '' : typeModule,
    offset: page * rowsPerPage,
    length: rowsPerPage
  });

  const { data: dataTokenRefresh, isFetching: isFetchingTokenRefresh, isError: isErroTokenRefresh } = useGetTokenRefreshPBI();

  const listActiveElement = useMemo(() => {
    return dataConnection.filter((res) => res.provider === 'sgbuildex').flatMap((res) => transformMetadata(res));
  }, [dataConnection]);

  const [dataDownload, setdataDownload] = useState(null);
  const {
    refetch: fetchDownload,
    isFetching: isLoadingDownload,
    isError: isErrorDownload
  } = useApsDownloadFile({
    type: dataDownload?.type,
    id: dataDownload?.id
  });
  const [idExtraction, setidExtraction] = useState(null);
  const {
    refetch: fetchDownloadCSV,
    isFetching: isLoadingDownloadCSV,
    isError: isErrorDownloadCSV
  } = useApsDownloadFileCSV(dataDownload?.id);

  useEffect(() => {
    if (dataDownload) {
      downloadFile();
    }
  }, [dataDownload]);

  const [open, setOpen] = useState(false);
  const [dialogEdit, setdialogEdit] = useState(false);
  const [viewDataModal, setviewDataModal] = useState(false);
  const [dataView, setdataView] = useState(null);
  const [openExtraction, setopenExtraction] = useState(false);
  const [openListDataDialog, setopenListDialog] = useState(false);
  const [connectors, setconnectors] = useState(null);
  const [openALertDialog, setopenALertDialog] = useState(false);
  const [openALertElement, setopenALertElement] = useState(false);
  const [labelAlertDialog, setlabelAlertDialog] = useState('');
  const [selectedId, setSelectedId] = useState(null);
  const [openActiveElement, setopenActiveElement] = useState(false);
  const [dashboardType, setdashboardType] = useState(false);

  const [selectedElement, setselectedElement] = useState(null);
  const [openDashboard, setopenDashboard] = useState(false);
  const [openDashboardConfirm, setOpenDashboardConfirm] = useState(false);
  const [selectedDashboardRow, setselectedDashboardRow] = useState(null);
  const [remainingToken, setRemainingToken] = useState(0);
  const [refreshStatus, setRefreshStatus] = useState(null);
  const [openRefreshConfirm, setOpenRefreshConfirm] = useState(false);
  const [usedToday, setUsedToday] = useState(0);

  useEffect(() => {
    setRemainingToken(resolveRemainingToken(dataTokenRefresh));
    const quota = dataTokenRefresh?.quota ?? dataTokenRefresh?.remainingQuota ?? dataTokenRefresh ?? {};
    setUsedToday(Number(quota.refreshesUsedToday) || 0);
  }, [dataTokenRefresh]);

  const handleConfirmElement = (param) => {
    setselectedElement(param);
    setopenActiveElement(false);
    setTimeout(() => {
      setopenALertElement(true);
    }, 100);
  };

  const handleConfirmDeleteElement = () => {
    // console.log(selectedElement)
    const payload = {
      connectionId: selectedElement.connection_id,
      element: selectedElement.element_id
    };
    deactivateElement(payload, {
      onSuccess: () => {
        setopenALertElement(false);
        setSnackbar({
          open: true,
          title: 'Deactivate Element Success',
          content: 'You succesfully deactivate element',
          type: 'success'
        });
      },

      onError: (error) => {
        setSnackbar({
          open: true,
          title: 'Deactivate Element failed',
          content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
          type: 'error'
        });
      }
    });
  };

  const handleSetDashboardType = (param) => {
    console.log(param);
    setdashboardType(param.type);
    setselectedDashboardRow(param);
    setopenDashboard(true);
  };

  const handleChangePage = (event, newPage) => {
    console.log(newPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const [snackbar, setSnackbar] = useState({
    open: false,
    title: '',
    content: '',
    type: 'error'
  });

  const handleCloseSnackbar = () => {
    setSnackbar({
      open: false,
      title: '',
      content: '',
      type: 'error'
    });
  };

  const handleAddExtraction = () => {
    setOpen(true);
  };

  const handleCloseExtraction = () => {
    setOpen(false);
  };

  const handleOpenExtractionDialog = (param) => {
    const { provider } = param;
    console.log(provider);
    setOpen(false);
    setTimeout(() => {
      setconnectors(param);

      if (provider === 'googledrive') {
        setopenListDialog(true);
      }

      if (provider === 'autodesk') {
        setopenExtraction(true);
        handleBackHub();
      }

      if (provider === 'sgbuildex') {
        setopenSgbuildexModule(true);
      }
    }, 200);
  };

  const handleCloseListDataDialog = (param) => {
    console.log(param);
    if (!param) {
      setopenListDialog(false);
      return false;
    }

    const payload = {
      fileId: param.id,
      type: 'spreadsheets',
      connection_user_name: connectionOwnerName
    };
    console.log(payload);
    extractGoogleSheet(payload, {
      onSuccess: () => {
        setopenListDialog(false);
        handleCloseExtractionDialog('success', 'spreadsheets');
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          title: 'Extract data failed',
          content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
          type: 'error'
        });
      }
    });
  };

  const handleConfirmSgbuildex = (param, type) => {
    // console.log({ param, type });
    setopenSgbuildexModule(false);
    if (param === 'success') {
      const msg = {
        title: `Add activate element success`,
        content: `You Successfully activate ${type} element`
      };

      setTimeout(() => {
        setSnackbar({
          open: true,
          title: msg.title,
          content: msg.content,
          type: 'success'
        });
      }, 500);
    }
  };

  const handleFileUpload = (data) => {
    setOpen(false);
    const payload = {
      type: data.provider,
      file: data.file
    };
    // console.log({payload, data});
    extractExcel(payload, {
      onSuccess: () => {
        setTimeout(() => {
          setSnackbar({
            open: true,
            title: `Extract Excel Success`,
            content: `You Successfully extracting data from excel file`,
            type: 'success'
          });
        }, 500);
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          title: 'Extract data failed',
          content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
          type: 'error'
        });
      }
    });
  };

  const handleFileEtsUpload = (data) => {
    setOpen(false);
    const payload = {
      type: data.provider,
      file: data.file
    };
    // console.log({payload, data});
    extractEtsExcel(payload, {
      onSuccess: () => {
        setTimeout(() => {
          setSnackbar({
            open: true,
            title: `Extract ETS Excel Success`,
            content: `You Successfully extracting data from excel file`,
            type: 'success'
          });
        }, 500);
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          title: 'Extract data failed',
          content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
          type: 'error'
        });
      }
    });
  };

  const handleCloseExtractionDialog = (param, type) => {
    console.log({ param, type });
    setopenExtraction(false);
    if (param === 'success') {
      const msgSchedule = {
        title: `Add Schedule Extraction success`,
        content: `You Successfully add schedule extraction`
      };
      const msg = {
        title: `Extract ${type} success`,
        content: `You Successfully extracting ${type} module`
      };
      setTimeout(() => {
        setSnackbar({
          open: true,
          title: type === 'schedule' ? msgSchedule.title : msg.title,
          content: type === 'schedule' ? msgSchedule.content : msg.content,
          type: 'success'
        });
      }, 500);
    }
  };

  const handleBackHub = () => {
    setHubName('');
    setCloseProject(false);
  };

  const handleViewDataExtraction = (data) => {
    setviewDataModal(true);
    setdataView(data);
  };

  const handleEditDataExtraction = (data) => {
    setdialogEdit(true);
    setSelectedId(data.id);
    setdataView(data);
  };

  const handleConfirmEdit = (data) => {
    // console.log(param);
    // setdialogEdit(false);
    const payload = {
      id: selectedId,
      data
    };
    updateExtraction(payload, {
      onSuccess: () => {
        const message = {
          open: true,
          title: `Update Extraction success`,
          content: `You Successfully update extracting ${labelAlertDialog} module`,
          type: 'success'
        };
        setdialogEdit(false);
        setSelectedId(null);
        setTimeout(() => {
          setSnackbar(message);
        }, 500);
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          title: 'Update data failed',
          content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
          type: 'error'
        });
      }
    });
  };

  const handleCloseViewModal = () => {
    setviewDataModal(false);
  };

  const handleDeleteExtraction = ({ type, id }) => {
    setSelectedId(id);
    setlabelAlertDialog(type);
    setopenALertDialog(true);
  };

  const handleConfirmDelete = () => {
    deleteExtraction(selectedId, {
      onSuccess: () => {
        const message = {
          open: true,
          title: `Delete Extraction success`,
          content: `You Successfully delete extracting ${labelAlertDialog} module`,
          type: 'success'
        };
        setopenALertDialog(false);
        setlabelAlertDialog('');
        setSelectedId(null);
        setTimeout(() => {
          setSnackbar(message);
        }, 500);
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          title: 'Delete data failed',
          content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
          type: 'error'
        });
      }
    });
  };

  const handleDownloadFile = (data) => {
    const actions = getActionsByModuleType(data.type);
    if (actions.includes('download')) {
      setdataDownload({
        type: 'extract',
        data: data,
        id: data.id
      });
    }
  };

  const downloadFile = async () => {
    if (!dataDownload?.type || !dataDownload?.id) return;

    try {
      let downloadedFile;

      if (dataDownload.type === 'file') {
        downloadedFile = await fetchDownload();
      } else {
        downloadedFile = await fetchDownloadCSV();
      }

      if (!downloadedFile) return;

      let blob;

      if (dataDownload.type === 'file') {
        blob = new Blob([downloadedFile]);
      } else {
        blob = new Blob([downloadedFile.data], { type: 'text/csv;charset=utf-8;' });
      }

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;

      if (dataDownload.type === 'file') {
        a.download = `${dataDownload.type}-${dataDownload.id}.xlsx`;
      } else {
        const filename = `${dataDownload.type}-${dataDownload.data.type}-${dataDownload.data.metadata?.hub_name}-${dataDownload.data?.metadata?.project_name || dataDownload.data?.metadata?.name}.csv`;
        a.download = filename;
      }

      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download failed', err);
    }
  };

  const handleUpdatePowerBI = (module, table_name) => {
    const val = module === 'submittals' ? 'submittal' : module === 'issues' ? 'issue' : 'rfis';
    updateParameterPowerBI(
      { module: val, table_name },
      {
        onSuccess: () => {},
        onError: (error) => {
          console.log('failder update power BI', error);
        }
      }
    );
  };

  const handleRefreshPowerBI = () => {
    return new Promise((resolve, reject) => {
      refreshPowerBI(null, {
        onSuccess: (res) => {
          setRefreshStatus(res?.refreshStatus ?? null);
          const token = resolveRemainingToken(res);

          setRefreshTokenPBI(token);
          setRemainingToken(token);

          const quota = res?.quota ?? res?.remainingQuota ?? res ?? {};
          setUsedToday(Number(quota.refreshesUsedToday) || 0);

          if (token !== undefined && token !== null) {
            localStorage.setItem('remaining_token', token);
          }

          setSnackbar({
            open: true,
            title: 'Power BI Refresh',
            content: res?.refreshStatus?.skipped
              ? `Refresh skipped: ${res.refreshStatus.message}`
              : 'Dataset refresh triggered successfully',
            type: res?.refreshStatus?.skipped ? 'warning' : 'success'
          });

          setOpenRefreshConfirm(false);
          resolve(res);
        },

        onError: (error) => {
          console.log('failed refresh power BI', error);
          setSnackbar({
            open: true,
            title: 'Refresh failed',
            content: error?.response?.data?.message || error?.message || 'Something went wrong while refreshing Power BI.',
            type: 'error'
          });
          setOpenRefreshConfirm(false);
          reject(error);
        }
      });
    });
  };

  const isNotAccDetail = dataView?.type !== 'excel' && dataView?.type !== 'spreadsheets';
  const isLoading = isExtractingExcel;
  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={isLoading}
        // onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {snackbar.open && <SnackbarAlert open={snackbar.open} handleClose={handleCloseSnackbar} message={snackbar} />}
      <RefreshConfirmDialog
        open={openRefreshConfirm}
        onClose={() => setOpenRefreshConfirm(false)}
        onConfirm={handleRefreshPowerBI}
        remainingQuota={remainingToken}
        usedToday={usedToday}
        isLoading={isRefreshPowerBI}
      />
      <Box>
        <Stack direction={'row'} justifyContent={'space-between'} spacing={2} flex={1}>
          <TextField
            sx={{
              width: '20%'
            }}
            id="outlined-select-currency"
            select
            label="Select Type"
            defaultValue="all"
            value={typeModule}
            onChange={(e) => settypeModule(e.target.value)}
            // helperText="Please select your currency"
          >
            {moduleTypes.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <Stack direction={'row'} spacing={3} alignItems={'center'}>
            <Tooltip title="Refresh Power BI">
              <IconButton color="primary" onClick={() => setOpenRefreshConfirm(true)} disabled={isRefreshPowerBI}>
                {isRefreshPowerBI ? <CircularProgress size={24} color="inherit" /> : <AutorenewIcon />}
              </IconButton>
            </Tooltip>
            <IconButton
              color="primary"
              aria-label="Connection"
              disabled={listActiveElement?.length === 0}
              onClick={() => setopenActiveElement(true)}
            >
              <Badge
                badgeContent={listActiveElement?.length}
                color="error"
                overlap="circular"
                sx={{
                  '& .MuiBadge-badge': {
                    animation: 'softBlink 1.5s ease-in-out infinite'
                  },
                  '@keyframes softBlink': {
                    '0%, 100%': { opacity: 1 },
                    '50%': { opacity: 0.4 }
                  }
                }}
              >
                <LinkIcon />
              </Badge>
            </IconButton>
            <Button sx={{ fontWeight: 'bold' }} onClick={handleAddExtraction} variant="contained" startIcon={<AddIcon />}>
              ADD
            </Button>
          </Stack>
        </Stack>
        <Stack spacing={2} sx={{ mt: 3, mb: 2 }}>
          <Paper
            sx={{
              background: '#fff',
              p: 3,
              borderRadius: 2,
              overflow: 'hidden'
            }}
          >
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow sx={{ bgcolor: '#ffffff' }}>
                    <TableCell>
                      <strong>Type</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Data Source</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Created At</strong>
                    </TableCell>
                    <TableCell align="left">
                      <strong>Action</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {dataExtraction &&
                    dataExtraction?.data.map((row) => {
                      const actions = getActionsByModuleType(row.type);
                      const isNotAcc = row.type !== 'excel' && row.type !== 'spreadsheets';
                      return (
                        <TableRow key={row.id}>
                          <TableCell>
                            <Typography fontWeight="bold">{moduleTypes.find((res) => res.value === row.type)?.label}</Typography>
                          </TableCell>
                          <TableCell>
                            {isNotAcc && (
                              <Typography variant="body2" color="text.secondary">
                                {[
                                  row?.metadata?.connection_user_name,
                                  row?.metadata?.hub_name,
                                  row?.metadata?.project_name || row?.metadata?.name
                                ]
                                  .filter(Boolean)
                                  .join(' | ')}
                              </Typography>
                            )}

                            {row.type == 'excel' && (
                              <Typography variant="body2" color="text.secondary">
                                {row.metadata.name}
                              </Typography>
                            )}
                            {row.type == 'spreadsheets' && (
                              <Typography variant="body2" color="text.secondary">
                                {row.metadata.name}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" color="text.secondary">
                              {row.created_at || row.createdAt ? moment(row.created_at || row.createdAt).format('YYYY-MM-DD HH:mm:ss') : '-'}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Box sx={{ display: 'flex', gap: 2.5 }}>
                              {actions.includes('view') && (
                                <ActionButton
                                  title="View Data"
                                  color="first"
                                  icon={<VisibilityOutlinedIcon fontSize="small" />}
                                  onClick={() => handleViewDataExtraction(row)}
                                />
                              )}

                              {actions.includes('edit') && (
                                <ActionButton
                                  onClick={() => handleEditDataExtraction(row)}
                                  title="Edit Data"
                                  color="warning"
                                  icon={<EditOutlinedIcon fontSize="small" />}
                                />
                              )}

                              {actions.includes('dashboard') && (
                                <ActionButton
                                  onClick={() => handleSetDashboardType(row)}
                                  title="View Dashboard"
                                  color="info"
                                  icon={<DashboardOutlinedIcon fontSize="small" />}
                                />
                              )}

                              {actions.includes('download') && (
                                <ActionButton
                                  title="Download Data"
                                  color="success"
                                  icon={<DownloadOutlinedIcon fontSize="small" />}
                                  onClick={() => handleDownloadFile(row)}
                                />
                              )}

                              {actions.includes('delete') && (
                                <ActionButton
                                  title="Delete Data"
                                  color="error"
                                  icon={<DeleteOutlineOutlinedIcon fontSize="small" />}
                                  onClick={() => handleDeleteExtraction(row)}
                                />
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={dataExtraction?.totalRows || 0}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </Paper>
        </Stack>
        <ScheduleExtractionPage setSnackbar={setSnackbar} />

        <PowerBIDialog
          open={openDashboard}
          onClose={() => setopenDashboard(false)}
          pageName={dashboardType} // change page here
          metadata={selectedDashboardRow?.metadata}
        />

        {open && (
          <ListConnectorsDialog
            module={'extraction'}
            open={open}
            onCancel={handleCloseExtraction}
            onConfirm={(param) => {
              if (param.provider === 'excel') {
                handleFileUpload(param);
              } else if (param.provider === 'ets') {
                handleFileEtsUpload(param);
              } else {
                handleOpenExtractionDialog(param);
              }
            }}
          />
        )}
        {openActiveElement && (
          <ListActiveElementDialog open={openActiveElement} onCancel={() => setopenActiveElement(false)} onConfirm={handleConfirmElement} />
        )}

        {openListDataDialog && (
          <GoogleListItemDialog
            dataConnection={connectors}
            open={openListDataDialog}
            loading={isExtractingGoogleSheet}
            onCancel={() => handleCloseListDataDialog(null)}
            onConfirm={(param) => handleCloseListDataDialog(param)}
          />
        )}

        <ConfirmDeleteDialog
          open={openALertDialog}
          loading={isDeletingExtraction}
          onCancel={() => setopenALertDialog(false)}
          onConfirm={handleConfirmDelete}
          title={`Delete Extraction`}
          description={`Are you sure you want to delete ${labelAlertDialog} extraction?`}
        />

        <ConfirmDeleteDialog
          open={openALertElement}
          loading={isDeactivateElement}
          onCancel={() => setopenALertElement(false)}
          onConfirm={handleConfirmDeleteElement}
          title={`Delete Receive Element`}
          description={`Are you sure you want to delete receive element?`}
        />

        <SgbuildexModuleScreen
          open={openSgbuildexModule}
          onClose={() => setopenSgbuildexModule(false)}
          onConfirm={handleConfirmSgbuildex}
          setSnackbar={setSnackbar}
        />

        <EditDataPage
          open={dialogEdit}
          onClose={() => setdialogEdit(false)}
          dataView={dataView}
          onConfirm={handleConfirmEdit}
          setSnackbar={setSnackbar}
        />

        <Dialog
          fullScreen
          open={openExtraction}
          onClose={handleCloseExtractionDialog}
          slots={{
            transition: Transition
          }}
        >
          <AppBar sx={{ position: 'relative' }}>
            <Toolbar>
              {openProject && (
                <IconButton edge="start" color="inherit" onClick={handleBackHub} aria-label="close">
                  <ArrowBackIcon />
                </IconButton>
              )}
              <Typography sx={{ ml: 2, flex: 1, fontWeight: 'bold' }} variant="h5" component="div">
                {openProject ? `Hub ${hubname}` : 'Choose Hub'}
              </Typography>
              <Button autoFocus color="inherit" onClick={handleCloseExtractionDialog}>
                CLOSE
              </Button>
            </Toolbar>
          </AppBar>
          <HubPage closeDialog={handleCloseExtractionDialog} setSnackbar={setSnackbar} />
        </Dialog>

        <Dialog
          fullScreen
          open={viewDataModal}
          onClose={handleCloseViewModal}
          slots={{
            transition: Transition
          }}
        >
          <AppBar sx={{ position: 'relative' }}>
            <Toolbar>
              {dataView?.type == 'spreadsheets' && (
                <Typography sx={{ ml: 2, flex: 1, fontWeight: 'bold' }} variant="h6" component="div">
                  {dataView?.metadata.name}
                </Typography>
              )}
              {dataView?.type == 'excel' && (
                <Typography sx={{ ml: 2, flex: 1, fontWeight: 'bold' }} variant="h6" component="div">
                  {dataView?.metadata.name}
                </Typography>
              )}

              {isNotAccDetail && (
                // <Typography sx={{ ml: 2, flex: 1, fontWeight: 'bold' }} variant="h6" component="div">
                //   {dataView?.metadata.connection_user_name} | {dataView?.metadata.hub_name} |{' '}
                //   {dataView?.metadata.project_name || dataView?.metadata.name}
                // </Typography>
                <Typography sx={{ ml: 2, flex: 1, fontWeight: 'bold' }} variant="h6" component="div">
                  {[
                    dataView?.metadata?.connection_user_name,
                    dataView?.metadata?.hub_name,
                    dataView?.metadata?.project_name || dataView?.metadata?.name
                  ]
                    .filter(Boolean)
                    .join(' | ')}
                </Typography>
              )}

              <Button autoFocus color="inherit" onClick={handleCloseViewModal}>
                CLOSE
              </Button>
            </Toolbar>
          </AppBar>
          <ViewDataPage data={dataView} table={dataView?.table_name} />
        </Dialog>
      </Box>
    </>
  );
}
